<template>
<div id="scheme">
    <Header type="static"/>
    <router-view/>
    <Footer class="mt20" />
</div>
</template>
<script>
import Header from '@/components/common/WebHeader'
import Footer from '@/components/common/Footer'
export default {
    name: 'Scheme',
    components:{ Header,Footer },
    created () {
        window.vue=this;
    }
}
</script>
<style scoped lang="less">
#scheme{
    background:#fff;
    min-width: 1200px;
    overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/pages/scheme/Scheme.vue